import { render, staticRenderFns } from "./employee-item.vue?vue&type=template&id=09fa6702"
import script from "./employee-item.vue?vue&type=script&lang=js"
export * from "./employee-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports